export const INTERCOM_UPDATE_SETTINGS = '@analytics/intercom/INTERCOM_UPDATE_SETTINGS';
export const INTERCOM_START_PRODUCT_TOUR = '@analytics/intercom/INTERCOM_START_PRODUCT_TOUR';

export const updateIntercomSettings = ({ userInfo = {}, company = {} }) => ({
    type: INTERCOM_UPDATE_SETTINGS,
    payload: {
        userInfo,
        company,
    },
});

export const startProductTour = productTourId => ({
    type: INTERCOM_START_PRODUCT_TOUR,
    payload: {
        productTourId,
    },
});
